import { render, staticRenderFns } from "./MobileIdVerification.vue?vue&type=template&id=557be0a8"
import script from "./MobileIdVerification.vue?vue&type=script&lang=js"
export * from "./MobileIdVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports